import { Box } from "@mui/material";
import { useState } from "react";
import { useGetAppIntegrationStatus } from "../../hooks/useGetAppIntegrationStatus";
import { AppConfig } from "../../interfaces/appIntegration.interfaces";
import { AppDetailBody } from "./AppDetailBody";
import { AppDetailDescription } from "./AppDetailDescription";
import { AppDetailHero } from "./AppDetailHero";

interface Props {
  app: AppConfig;
  onInstall?: (appId: string) => void;
  onUninstall?: (appId: string) => void;
  isInstalled?: boolean;
}

export const AppDetail = ({ app, onInstall, onUninstall }: Props) => {
  const [isFavorited, setIsFavorited] = useState(false);
  const { data: status = "not_installed", isLoading: statusLoading } = useGetAppIntegrationStatus(app);
  const isInstalled = app.companyIntegrations.length > 0;

  const handleInstall = () => {
    if (isInstalled) {
      onUninstall?.(app.id);
    } else {
      onInstall?.(app.id);
    }
  };

  return (
    <Box>
      <Box sx={{ width: "100%", minHeight: "max", bgcolor: "var(--fx-surface-base, #FFFFFF)", display: "flex", flexDirection: { xs: "column", md: "row" } }}>
        <AppDetailHero
          app={app}
          isInstalled={isInstalled}
          statusLoading={statusLoading}
          isFavorited={isFavorited}
          onInstall={handleInstall}
          onFavorite={() => setIsFavorited(!isFavorited)}
        />
      </Box>

      <AppDetailBody app={app} isInstalled={isInstalled} />

      <Box sx={{ width: "100%", py: 2 }}>
        <Box sx={{ maxWidth: 1200, mx: "auto" }}>
          <AppDetailDescription app={app} />
        </Box>
      </Box>
    </Box>
  );
};
